import React from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "react-bootstrap";
import "./BranchModal.css";

const BranchModal = ({
  show,
  onHide,
  title,
  description,
  buttonText,
  onButtonClick,
  isSuccess,
  children,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      className={`branch-modal ${isSuccess ? "success-modal" : ""}`}
    >
      <Modal.Header className={isSuccess ? "success-header" : ""}>
        {isSuccess && (
          <div className="success-icon">
            <i className="fas fa-check-circle"></i>
          </div>
        )}
      </Modal.Header>
      <Modal.Body>
        <Modal.Title className="modal-title">{title}</Modal.Title>
        {description && <p className="modal-description">{description}</p>}
        {children}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant={isSuccess ? "primary" : "secondary"}
          onClick={onButtonClick || onHide}
          className="modal-button"
        >
          {buttonText || "OK"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

BranchModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  onButtonClick: PropTypes.func,
  isSuccess: PropTypes.bool,
  children: PropTypes.node,
};

BranchModal.defaultProps = {
  description: null,
  buttonText: "OK",
  onButtonClick: null,
  isSuccess: false,
  children: null,
};

export default BranchModal;
